// ** Redux Imports
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('appPayDeductions/setLoading', async (loadingState) => ({...loadingState}))

export const getData = createAsyncThunk('appPayDeductions/getData', async (params, {dispatch, getState}) => {
    dispatch(setLoading({getData: true}))
    const response = await axios.get('/PayPeriodDeductions/List', {params})
    dispatch(setLoading({getData: false}))
    return {
        params,
        data: response?.data
    }
})

export const appPayDeductionsSlice = createSlice({
    name: 'appPayDeductions',
    initialState: {
        data: [],
        totalRecords: 1,
        params: {},
        loadingState: {getData: false}
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload?.data?.data?.list??[]
                state.totalRecords = action.payload?.data?.data?.totalRecords??0
                state.params = action.payload.params
            })
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loadingState =  {...state.loadingState, ...action.payload}
            })
    }
})

export default appPayDeductionsSlice.reducer
